import { toast } from "react-toastify";

export const showToast = message => {
  let Toast = toast.error(message, {
    position: "bottom-center"
  });
  return Toast;
};
